module.exports = __webpack_public_path__ + "img/akun.33e7df0.png";